import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ForWhom() {
  const forYou = ['Quieres un método directo y práctico', 'Estás listo para dejar de improvisar con tu dinero', 'Tienes ganas de orden, claridad y paz mental'];
  const notForYou = ['buscas una solución mágica sin hacer cambios', 'quieres “hacerte rica rápido”', 'no estás dispuesta a mirar tus números de frente (sin juicio, pero con acción)'];
  return <section className="py-20 bg-navy-800/50" data-id="element-113">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-114">
        <FadeIn data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-116">
            ¿Para quién es este eBook?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-117">
          {/* For You */}
          <FadeIn delay={0.2} direction="right" data-id="element-118">
            <div className="bg-teal-900/20 border border-teal-500/20 rounded-2xl p-8 h-full" data-id="element-119">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-120">
                <div className="bg-green-500/20 p-2 rounded-full text-green-400" data-id="element-121">
                  <CheckIcon className="w-6 h-6" data-id="element-122" />
                </div>
                Para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-123">
                {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-124">
                    <CheckIcon className="w-5 h-5 text-green-400 mt-1 flex-shrink-0" data-id="element-125" />
                    <span className="text-lg text-slate-300" data-id="element-126">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For You */}
          <FadeIn delay={0.4} direction="left" data-id="element-127">
            <div className="bg-red-950/10 border border-red-500/20 rounded-2xl p-8 h-full" data-id="element-128">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-129">
                <div className="bg-red-500/20 p-2 rounded-full text-red-400" data-id="element-130">
                  <XIcon className="w-6 h-6" data-id="element-131" />
                </div>
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-132">
                {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-133">
                    <XIcon className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-134" />
                    <span className="text-lg text-slate-300" data-id="element-135">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}